/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PlumbingInputs */

const en_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plumbing`)
};

const es_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontanería / Plomería`)
};

const fr_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plomberie`)
};

const de_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanitär`)
};

const ja_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配管`)
};

const zh_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水管服务`)
};

const ar_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سباكة`)
};

const id_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledeng`)
};

const it_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idraulica`)
};

const ru_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сантехника`)
};

const pt_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encanamento`)
};

const ko_val_plumbing = /** @type {(inputs: Val_PlumbingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배관`)
};

/**
* | output |
* | --- |
* | "Plumbing" |
*
* @param {Val_PlumbingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_plumbing = /** @type {((inputs?: Val_PlumbingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PlumbingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_plumbing(inputs)
	if (locale === "es") return es_val_plumbing(inputs)
	if (locale === "fr") return fr_val_plumbing(inputs)
	if (locale === "de") return de_val_plumbing(inputs)
	if (locale === "ja") return ja_val_plumbing(inputs)
	if (locale === "zh") return zh_val_plumbing(inputs)
	if (locale === "ar") return ar_val_plumbing(inputs)
	if (locale === "id") return id_val_plumbing(inputs)
	if (locale === "it") return it_val_plumbing(inputs)
	if (locale === "ru") return ru_val_plumbing(inputs)
	if (locale === "pt") return pt_val_plumbing(inputs)
	return ko_val_plumbing(inputs)
});